const REFRESH_FRACTION = 0.8;
const JITTER_FRACTION = 0.1;
const WAKE_WINDOW_MS = 60_000;

export const MIN_REFRESH_DELAY_MS = 5_000;
export const REFRESH_RETRY_DELAYS_MS: readonly number[] = [1000, 2000, 4000];

export function nextRefreshDelayMs(expiresAt: string, now: number, rand: () => number): number {
  const expiry = Date.parse(expiresAt);
  if (Number.isNaN(expiry)) return MIN_REFRESH_DELAY_MS;
  const jitter = 1 + (rand() * 2 - 1) * JITTER_FRACTION;
  return Math.max((expiry - now) * REFRESH_FRACTION * jitter, MIN_REFRESH_DELAY_MS);
}

export function shouldRefreshOnWake(expiresAt: string, now: number): boolean {
  const expiry = Date.parse(expiresAt);
  return Number.isNaN(expiry) || expiry - now <= WAKE_WINDOW_MS;
}
